/* eslint-disable react-hooks/exhaustive-deps */
import { useMemo } from 'react';
import { Menu, Divider, Button } from 'antd';
import Icon from '../icons/Icon';
import { routesPath } from '../../constants/routesPath';
import { useTranslation } from 'react-i18next';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { primitiveColors, spacing } from '../../../theming';
import classes from './SideMenu.module.scss';
import { useCredits } from '../../../context/CreditsContext';
import { menuItems } from '../../constants/menuItems';
import { useImpersonation } from '../../../hooks/useImpersonation';

const SideMenu = ({ closeMobileMenu, closeDrawer }) => {
    const { t } = useTranslation(['sidebar', 'leads', 'users', 'businesses', 'teams', 'menu']);
    const navigate = useNavigate();
    const { credits } = useCredits();
    // no purchases in a read-only impersonation
    const { isImpersonating } = useImpersonation();

    const location = useLocation();

    const leftMenu = useMemo(
        () =>
            [...menuItems].map(({ key, route, iconName }) => {
                const isActive = location.pathname === route;
                const color = isActive ? primitiveColors.main : primitiveColors.mainText;

                return {
                    key: t(`sidebar:${key}`),
                    route,
                    title: <span style={{ color }}>{t(`sidebar:${key}`)}</span>,
                    icon: <Icon color={color} name={iconName} />,
                    label: (
                        <span className={classes.menuItemNav} style={{ color }}>
                            {t(`sidebar:${key}`)}
                        </span>
                    ),
                };
            }),
        [t, location.pathname]
    );

    const onMenuClick = ({ key }) => {
        const menuItem = leftMenu.find(item => item.key === key);
        if (menuItem?.route && location.pathname !== menuItem.route) {
            navigate(menuItem.route);
        }

        if (closeDrawer) {
            closeDrawer();
        }

        if (closeMobileMenu) {
            closeMobileMenu();
        }
    };

    return (
        <>
            {/* Uncomment next block if needed, in future */}
            {/* <div className={classes.myAccount}>{t('sidebar:my-account')}</div>
            <Divider
                style={{
                    backgroundColor: primitiveColors.divider,
                    height: 1,
                    marginTop: spacing[5],
                    marginBottom: spacing[5],
                }}
            /> */}
            <div className={classes.creditsWrapper}>
                <div className={classes.credits}>
                    <div className={classes.creditsLabel}>{t('sidebar:my-credits')}:</div>
                    <div className={classes.creditsValue}>{credits || 0}</div>
                </div>
                <Button
                    className={classes.getMoreCredits}
                    type="primary"
                    size="large"
                    disabled={isImpersonating}
                    onClick={() => {
                        navigate(routesPath.ROOT.PAYMENT);

                        if (closeDrawer) {
                            closeDrawer();
                        }

                        if (closeMobileMenu) {
                            closeMobileMenu();
                        }
                    }}
                >
                    {t('sidebar:get-button')}
                </Button>
            </div>
            <Divider
                style={{
                    backgroundColor: primitiveColors.divider,
                    height: 1,
                    marginTop: spacing[5],
                    marginBottom: spacing[5],
                }}
            />
            <Menu
                onClick={onMenuClick}
                selectedKeys={[location.pathname]}
                mode="inline"
                style={{
                    height: '100%',
                    borderRight: 0,
                    backgroundColor: 'inherit',
                    color: `${primitiveColors.gray900} !important`,
                }}
                overlayinnertyle={{
                    backgroundColor: primitiveColors.gray50,
                }}
                items={leftMenu}
            />
            <Divider
                style={{
                    backgroundColor: primitiveColors.divider,
                    height: 1,
                    marginTop: spacing[5],
                    marginBottom: spacing[5],
                }}
            />
            {/* <Link to={routesPath.ROOT.HELP} className={classes.helpWrapper}>
                <Icon
                    color={location.pathname === routesPath.ROOT.HELP ? primitiveColors.main : primitiveColors.mainText}
                    name="help"
                />
                <span
                    className={classes.menuItemNav}
                    style={{
                        color:
                            location.pathname === routesPath.ROOT.HELP
                                ? primitiveColors.main
                                : primitiveColors.mainText,
                    }}
                >
                    {t('sidebar:help')}
                </span>
            </Link> */}
        </>
    );
};

export default SideMenu;
